<p>{{ message }}</p>
<p>Are you sure?</p>
<div class="buttons">
  <button class="btn btn-outline-dark" (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-success" (click)="ok()">
    <i class="fas fa-check"></i> <span>Confirm</span>
  </button>
</div>
